<template>
<div class="c-step step-1">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy istnieje możliwość dostawy samochodu na
      Państwa posesji?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step1',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer) {
      if (answer == 'Tak') {
        this.$store.dispatch('answer', {
          step: '1',
          answer: answer
        })
      } else {
        this.$store.dispatch('answer', {
          step: '1',
          answer: answer
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
